





























import {Component, Prop, Vue} from "vue-property-decorator";
import DeviceRowMobile from "@/components/device/DeviceRowMobile.vue";
import DeviceRow from "@/components/device/DeviceRow.vue";
import {Device} from "@/types/core";
import {CoreClient, curCoreClient} from "@/services/CoreClient";

@Component({
  components: {
    DeviceRow,
    DeviceRowMobile,
  }
})
export default class DevicesUnderConfigurationSection extends Vue {
  @Prop({ default: () => '', type: String}) groupId!:string;
  @Prop({ default: () => {}, type: Object}) bus!:Vue;

  deviceList:Device[] = [];
  errorMsg:string = '';

  // internal dependencies
  private coreClient:CoreClient = curCoreClient;

  async mounted() {
    this.bus.$on('refresh', async () => {
      this.deviceList = await this.loadDevices(this.groupId);
    });

    this.deviceList = await this.loadDevices(this.groupId);
  }

  async loadDevices(groupId: string):Promise<Device[]> {
    const reply = await this.coreClient.getDevicesInGroup({
      skip: 0,
      limit: 100,
      groupIdList: groupId,
    });

    if (reply.errorMsg) {
      this.errorMsg = reply.errorMsg;
    }

    return reply.deviceList as Device[];
  }

  get showDeviceRows() {
    // TODO: implement logic - when loading don't show the rows
    return true;
  }
}
